import { render, staticRenderFns } from "./assays.vue?vue&type=template&id=e952293a&"
import script from "./assays.vue?vue&type=script&lang=js&"
export * from "./assays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports